import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NumerologySamplePersonas from '../../components/numerology/NumerologySamplePersonas';
import { SAMPLE_TARGET_YEAR } from '../../lib/numerology/samplePersonas';

const PAGE_TITLE = 'Sample readings for study | Numerology | Astral Moon Magic';

export default function NumerologySamplesPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = PAGE_TITLE;
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <>
      <section className="amm-hero">
        <div className="amm-kicker">Study</div>
        <h1>Sample readings</h1>
        <p className="amm-lead">
          Edgar and Marie are study examples built from historical birth data. They show how a full interpretation is
          structured — what is analyzed, how patterns are read, and how sections connect — so you can learn the
          framework before applying it to your own chart.
        </p>
      </section>

      <NumerologySamplePersonas />

      <footer className="amm-num-samples-page-foot">
        <p className="amm-num-samples-page-foot__note">
          Personal Year uses {SAMPLE_TARGET_YEAR} in both examples so you can compare structure side by side.
        </p>
        <p className="amm-num-samples-page-foot__note">
          Use these readings to understand structure and symbolism before you review your own report.
        </p>
        <p className="amm-num-samples-page-foot__back">
          <Link className="amm-text-link" to="/numerology/study">
            Back to course
          </Link>
        </p>
      </footer>
    </>
  );
}
